import { useState } from 'react';

import { Link, Stack } from '@mui/material';
import cx from 'classnames';
import { AnimatePresence, motion } from 'motion/react';
import { useTranslation } from 'react-i18next';

import styles from './CopyableLink.module.scss';
import { IconButton } from '../IconButton';

interface CopyableLinkProps {
  href: string;
  value: string;
  automationId?: string;
}

export const CopyableLink = ({
  href,
  value,
  automationId,
}: CopyableLinkProps) => {
  const { t } = useTranslation('ui');
  const [copied, setCopied] = useState(false);

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={0.5}
      className={styles.CopyableLink}
    >
      <Link href={href}>{value}</Link>
      <AnimatePresence mode="popLayout" initial={false}>
        <motion.span
          key={copied ? 'check' : 'copy'}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          style={{ display: 'inline-flex' }}
        >
          <IconButton
            iconName={copied ? 'check' : 'content_copy'}
            tooltip={copied ? t('entityField.Copied') : t('entityField.Copy')}
            size="tiny"
            tooltipProps={{ open: copied ? true : undefined }}
            className={cx(styles.CopyButton, {
              [styles.CopyButtonSuccess]: copied,
            })}
            onClick={() => {
              void navigator.clipboard.writeText(value).then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
              });
            }}
            data-automation-id={automationId}
          />
        </motion.span>
      </AnimatePresence>
    </Stack>
  );
};
